import i18n from '@/i18n';

export const REPORT_TYPE = Object.freeze({ GENERAL: 0, BUG: 1, IMPROVEMENT: 2, FEATURE_REQUEST: 3, OTHER: 4 });
export const REPORT_PLATFORM = Object.freeze({ APP: 0, PORTAL: 1 });
export const REPORT_STATUS = Object.freeze({ SUBMITTED: 0, REVIEWING: 1, RESOLVED: 2 });

export const reportTypeOptions = () => [
    { value: REPORT_TYPE.GENERAL, text: i18n.t('report.general') },
    { value: REPORT_TYPE.BUG, text: i18n.t('report.bug') },
    { value: REPORT_TYPE.IMPROVEMENT, text: i18n.t('report.improvement') },
    { value: REPORT_TYPE.FEATURE_REQUEST, text: i18n.t('report.featureRequest') },
    { value: REPORT_TYPE.OTHER, text: i18n.t('report.other') },
];
export const reportPlatformOptions = () => [
    { value: REPORT_PLATFORM.APP, text: i18n.t('report.app') },
    { value: REPORT_PLATFORM.PORTAL, text: i18n.t('report.portal') },
];
export const reportStatusOptions = () => [
    { value: REPORT_STATUS.SUBMITTED, text: i18n.t('report.submitted') },
    { value: REPORT_STATUS.REVIEWING, text: i18n.t('report.reviewing') },
    { value: REPORT_STATUS.RESOLVED, text: i18n.t('report.resolved') },
];
